import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { createApi, getServiceApi, updateServiceApi } from "../../../../services/Admin/service";
import { Grid, Box, Button, Switch, TextField, FormControlLabel, Select } from "@mui/material";
import LoadingProgress from "../../../../components/LoadingProgress";
import { RouteAdmin } from "../../../../routes/RouteAdmin";
import { MenuItem } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Card from "../../../../components/Admin/Card";

export default function Fields() {
    const { id } = useParams()
    const history = useNavigate()

    const [msgSuccess, setMsgSuccess] = useState(false)
    const [msgDanger, setMsgDanger] = useState(null)
    const [loading, setLoading] = useState(true)
    const [initialValues, setInitialValues] = useState(defaultValues())

    const serviciosTypeOptions = [
        { id: 'KEY_HOUER', name: 'Precio por hora' },
        { id: 'KEY_UNIT', name: 'Precio por unidad' }
    ]

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object(validationSchema()),
        enableReinitialize: true,
        onSubmit: async (formData) => {
            setMsgSuccess(false)
            setMsgDanger(null)

            if (id) {
                updateServiceApi(formData).then(resp => {
                    setMsgSuccess(true)
                }).catch(err => {
                    setMsgDanger(err.response.data?.msg)
                })
            } else {
                createApi(formData).then(resp => {
                    history(`/dash-admin/tipo-servicios/edit/${resp.data.data.id}`);
                    setMsgSuccess(true)
                }).catch(err => {
                    setMsgDanger(err.response.data?.msg)
                })
            }
        },
    })

    // Llamamos a la API para obtener los datos del servicio
    useEffect(() => {
        if (id) {
            getServiceApi({ id: id }).then(resp => {
                setInitialValues({
                    id: resp.data.data.id,
                    name: resp.data.data.name,
                    pvp: resp.data.data.pvp,
                    iva: resp.data.data.iva,
                    isActive: resp.data.data.isActive,
                    serviceType: resp.data.data.serviceType || "KEY_HOUER"
                })
                setLoading(false)
            }).catch(err => {
                setLoading(false)
            })
        } else {
            setLoading(false)
        }
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps

    return (
       <Card>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={3}>
                    <Grid item md={12}>
                        <Grid item md={12}>
                            <h1>Configuraciones del servicio</h1>
                        </Grid>
                        <Box border={1} className="box-default" style={{ padding: "20px 10px 0px 10px" }}>
                            <LoadingProgress loading={loading} />
                            {!loading && (
                                <Grid container spacing={3}>
                                    {msgSuccess && (
                                        <Grid item md={12}>
                                            <Box className="alert-success">
                                                Los datos del servicio se han guardado correctamente
                                            </Box>
                                        </Grid>
                                    )}

                                    {msgDanger && (
                                        <Grid item md={12}>
                                            <Box className="alert-danger">
                                                {msgDanger.map((item) => {
                                                    return (
                                                        <span>
                                                            {" "}
                                                            {item} <br />{" "}
                                                        </span>
                                                    );
                                                })}
                                            </Box>
                                        </Grid>
                                    )}

                                    <Grid item md={6}>
                                        <TextField
                                            variant="outlined"
                                            label="* Nombre"
                                            className="form-control"
                                            name="name"
                                            type="text"
                                            value={formik.values.name}
                                            onChange={formik.handleChange}
                                            fullWidth
                                            size="small"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        {formik.errors.name && (
                                            <p className="text-100 text-danger mt-1">
                                                {formik.errors.name}
                                            </p>
                                        )}
                                    </Grid>
                                    <Grid item md={6}>
                                        <TextField
                                            variant="outlined"
                                            label="* Iva (%)"
                                            className="form-control"
                                            name="iva"
                                            type="text"
                                            value={formik.values.iva}
                                            onChange={formik.handleChange}
                                            helperText="Indique 21 para especificar un 21%"
                                            fullWidth
                                            size="small"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        {formik.errors.iva && (
                                            <p className="text-100 text-danger mt-1">
                                                {formik.errors.iva}
                                            </p>
                                        )}
                                    </Grid>

                                    <Grid item md={6}>
                                        <FormControl fullWidth size="small" variant="outlined">
                                            <InputLabel shrink htmlFor="serviceType">
                                                * Tipo de precio
                                            </InputLabel>
                                            <Select
                                                label="* Tipo de precio"
                                                name="serviceType"
                                                id="serviceType"
                                                value={formik.values.serviceType}
                                                onChange={(e) => {
                                                    formik.setFieldValue('serviceType', e.target.value);
                                                }}
                                                disabled={id ? true : false}
                                                displayEmpty
                                            >
                                                <MenuItem value="">
                                                    <em>Seleccione un tipo de precio</em>
                                                </MenuItem>
                                                {serviciosTypeOptions.map((servicio) => (
                                                    <MenuItem key={servicio.id} value={servicio.id}>
                                                        {servicio.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        {formik.errors.serviceType && (
                                            <p className="text-100 text-danger mt-1">
                                                {formik.errors.serviceType}
                                            </p>
                                        )}
                                    </Grid>

                                    <Grid item md={6}>
                                        <TextField
                                            variant="outlined"
                                            label={`* ${formik.values.serviceType === 'KEY_UNIT' ? 'Precio por unidad (€)' : 'Precio por hora (€)'}`}
                                            className="form-control"
                                            name="pvp"
                                            type="text"
                                            value={formik.values.pvp}
                                            onChange={formik.handleChange}
                                            fullWidth
                                            size="small"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        {formik.errors.pvp && (
                                            <p className="text-100 text-danger mt-1">
                                                {formik.errors.pvp}
                                            </p>
                                        )}
                                    </Grid>
                                    <Grid item md={3}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={formik.values.isActive}
                                                    onChange={formik.handleChange}
                                                    name="isActive"
                                                    color="primary"
                                                />
                                            }
                                            label="Mostrar"
                                        />
                                    </Grid>
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                    <Grid item md={12}>
                        {!loading ? (
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <div style={{ width: 200 }}>
                                    <Button
                                        type="button"
                                        href={RouteAdmin.TIPO_SERVICIOS_MANAGEMENT.path}
                                        variant="contained"
                                        className="MuiButton-containedCancel"
                                        fullWidth
                                        disableElevation
                                    >
                                        Cancel
                                    </Button>
                                </div>
                                <div style={{ width: 200, marginLeft: 20 }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        fullWidth
                                        disableElevation
                                    >
                                        Guardar
                                    </Button>
                                </div>
                            </div>
                        ) : null}
                    </Grid>
                </Grid>
            </form>
        </Card>
    );

}

// Declaramos los objetos del formulario
function defaultValues() {
    return {
        id: "",
        name: "",
        pvp: "",
        iva: "",
        isActive: true,
        serviceType: "KEY_HOUER"
    }
}

function validationSchema() {
    return {
        name: Yup.string().required("El nombre del servicio es obligatorio"),
        pvp: Yup.number().typeError('Introduzca los decimales con el punto, ej: 3.23').required("El precio por hora es obligatorio"),
        iva: Yup.string().required("El tipo de iva del servicio es obligatorio"),
        serviceType: Yup.string().required("El tipo de precio es obligatorio"),
    }
}
